import { usePersona } from '@/store/usePersona';

import { PERSONA_LABELS, PERSONA_ORDER, type Persona } from './types';
import styles from './PersonaSwitcher.module.css';

/**
 * Persona switcher — Axioma VII (persona = visual priority, not permission).
 * State persisted via Zustand+localStorage.
 */
export function PersonaSwitcher() {
  const persona = usePersona((s) => s.persona);
  const setPersona = usePersona((s) => s.setPersona);

  return (
    <label className={styles.root}>
      <span className={styles.hint}>Visão</span>
      <select
        className={styles.select}
        value={persona}
        onChange={(e) => setPersona(e.target.value as Persona)}
        aria-label="Mudar persona activa"
      >
        {PERSONA_ORDER.map((p) => (
          <option key={p} value={p}>
            {PERSONA_LABELS[p]}
          </option>
        ))}
      </select>
    </label>
  );
}
